import { Clock, GitBranch, Globe, MessageSquare, Zap } from 'lucide-react';

const FlowSidebar = () => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  const nodeTypes = [
    {
      type: 'triggerNode',
      label: 'Trigger',
      icon: <Zap className="h-5 w-5" />,
      color: 'bg-primary-500',
      description: 'Keyword or template response',
    },
    {
      type: 'messageNode',
      label: 'Message',
      icon: <MessageSquare className="h-5 w-5" />,
      color: 'bg-blue-500',
      description: 'Send a text or media',
    },
    {
      type: 'delayNode',
      label: 'Delay',
      icon: <Clock className="h-5 w-5" />,
      color: 'bg-amber-400',
      description: 'Wait for a duration',
    },
    {
      type: 'conditionNode',
      label: 'Condition',
      icon: <GitBranch className="h-5 w-5" />,
      color: 'bg-indigo-500',
      description: 'Branching logic',
    },
    {
      type: 'apiNode',
      label: 'API Request',
      icon: <Globe className="h-5 w-5" />,
      color: 'bg-emerald-500',
      description: 'Trigger external webhook',
    },
  ];

  return (
    <aside className="w-64 bg-white border-l border-gray-200 p-4 overflow-y-auto">
      <div className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 px-2">
        Components
      </div>
      <div className="space-y-3">
        {nodeTypes.map(node => (
          <div
            key={node.type}
            className="group p-3 bg-white border border-gray-200 rounded-xl cursor-grab hover:border-primary-500 hover:shadow-md transition-all active:cursor-grabbing"
            onDragStart={event => onDragStart(event, node.type)}
            draggable
          >
            <div className="flex items-center gap-3 mb-1">
              <div
                className={`p-2 rounded-lg text-white ${node.color} shadow-sm group-hover:scale-110 transition-transform`}
              >
                {node.icon}
              </div>
              <div className="text-sm font-semibold text-gray-900">
                {node.label}
              </div>
            </div>
            <p className="text-[11px] text-gray-500 leading-tight pl-1">
              {node.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-8 border-t border-gray-100 px-2">
        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">
          Editor Tips
        </h3>
        <ul className="text-[11px] text-gray-500 space-y-2 list-disc pl-4">
          <li>Drag nodes onto the canvas</li>
          <li>Connect dots to link actions</li>
          <li>Double click to edit details</li>
        </ul>
      </div>
    </aside>
  );
};

export default FlowSidebar;
